// @flow
import React from 'react';
import PropTypes from 'prop-types';
import SnackBar from '../../../../elements/SnackBar/SnackBar';
import {usePage} from '../../../page/utils';
import GoogleAnalyticsSection from './Sections/GoogleAnalyticsSection';
import {makeStyles, Typography} from '@material-ui/core';

import {colors} from '../../../../assets/styles/colors';
import LoadingSpinner from '../../../../elements/LoadingSpinner/LoadingSpinner';

import type {Theme} from '@material-ui/core';
import type {ReportRequest} from '../api';
import {useEffect} from 'react';
import {TIENDADA_LINKS} from '../../../../constants';
import {useInitializeStoreGoogleIntegration} from '../utils';

type Props = {
  fetchGAIntegration: () => void,
  updateGAIntegration: ({reportRequest: ReportRequest}) => void,
  isSaving?: boolean,
  saveSuccess?: boolean,
  trackingId?: string,
  error?: string,
  isFetchingGA?: boolean,
};

const useStyles = makeStyles((theme: Theme) => ({
  support: {
    margin: theme.spacing(1, 0),
  },
  headingSupport: {
    color: colors.grey900,
    fontSize: 18,
    fontWeight: 600,
  },
  infoSupport: {
    color: colors.grey900,
    fontSize: 14,
    '& span': {
      fontWeight: 500,
    },
  },
  infoLinkSupport: {
    color: colors.primary,
    fontWeight: 500,
  },
}));

export default usePage<Props>(Reports, 'Reports');

function Reports(props: Props) {
  const {
    fetchGAIntegration,
    updateGAIntegration,
    isSaving,
    saveSuccess,
    trackingId,
    error,
    isFetchingGA,
  } = props;
  const classes = useStyles();

  useInitializeStoreGoogleIntegration();

  useEffect(() => {
    fetchGAIntegration();
  }, [fetchGAIntegration]);

  return (
    <>
      {isFetchingGA && <LoadingSpinner />}
      <SnackBar
        mode="success"
        message={saveSuccess ? 'Actualizado correctamente.' : ''}
      />
      <SnackBar mode="error" message={error ? 'Error al actualizar.' : ''} />
      <GoogleAnalyticsSection
        trackingId={trackingId}
        updateGAIntegration={updateGAIntegration}
        isSaving={isSaving}
        saveSuccess={saveSuccess}
      />
      {/* <GoogleTagManagerSection /> */}
      <div className={classes.support}>
        <Typography className={classes.headingSupport}>
          ¿Tienes dudas?
        </Typography>
        <Typography className={classes.infoSupport}>
          Lee la{' '}
          <a
            href="https://tiendadateam.notion.site/Google-Analytics-1dac2eafc5474aaca65e2bde0c6c62c8"
            target="_BLANK"
            rel="noopener noreferrer"
            className={classes.infoLinkSupport}
          >
            guía de instalación
          </a>{' '}
          o contacta a nuestro{' '}
          <a
            href={TIENDADA_LINKS.customerSupport.general}
            target="_BLANK"
            rel="noopener noreferrer"
            className={classes.infoLinkSupport}
          >
            equipo de soporte
          </a>
          .
        </Typography>
      </div>
    </>
  );
}

Reports.propTypes = {
  fetchGAIntegration: PropTypes.func.isRequired,
  updateGAIntegration: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  saveSuccess: PropTypes.bool,
  trackingId: PropTypes.string,
  error: PropTypes.string,
  isFetchingGA: PropTypes.bool,
};
